import { PurchaseOrderRevisePage } from "@/features/purchase-order/pages/PurchaseOrderRevisePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-order/$id/revise")({
  component: PurchaseOrderRevisePage,
});
